
const Reports = ({ children }) => {
  return (
    <>
      {/* <Navlink/> */}
      {children}
    </>
  );
};

export default Reports;
